import { useData } from "@/context/DataContext";
import { Input } from "@/components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

const Field = ({ label, children }) => (
  <div className="flex flex-col gap-1">
    <span className="text-[10px] font-semibold uppercase tracking-[0.2em] text-slate-500">{label}</span>
    {children}
  </div>
);

export const FilterBar = ({ showGranularity = true }) => {
  const { masters, filters, setFilters } = useData();
  const set = (k) => (v) => setFilters((f) => ({ ...f, [k]: v }));

  const pickers = [
    ["client_id", "Client", masters.clients],
    ["campaign_id", "Campaign", masters.campaigns],
    ["manager_id", "Manager", masters.managers],
    ["via_id", "Via", masters.vias],
  ];

  return (
    <div
      className="mb-8 grid grid-cols-2 gap-3 border border-slate-200 bg-slate-50 p-4 md:grid-cols-4 lg:grid-cols-8"
      data-testid="filter-bar"
    >
      <Field label="From">
        <Input
          type="date"
          data-testid="filter-start-date"
          className="h-9 rounded-md border-slate-300 bg-white"
          value={filters.start}
          onChange={(e) => set("start")(e.target.value)}
        />
      </Field>
      <Field label="To">
        <Input
          type="date"
          data-testid="filter-end-date"
          className="h-9 rounded-md border-slate-300 bg-white"
          value={filters.end}
          onChange={(e) => set("end")(e.target.value)}
        />
      </Field>
      {pickers.map(([key, label, list]) => (
        <Field key={key} label={label}>
          <Select value={filters[key]} onValueChange={set(key)}>
            <SelectTrigger
              data-testid={`filter-${key.replace("_id", "")}`}
              className="h-9 rounded-md border-slate-300 bg-white"
            >
              <SelectValue placeholder={`All ${label}`} />
            </SelectTrigger>
            <SelectContent className="border border-slate-200 bg-white">
              <SelectItem value="all">All {label}s</SelectItem>
              {(list || []).map((o) => (
                <SelectItem key={o.id} value={o.id}>
                  {o.name}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </Field>
      ))}
      <Field label="Currency">
        <Select value={filters.currency} onValueChange={set("currency")}>
          <SelectTrigger data-testid="filter-currency" className="h-9 rounded-md border-slate-300 bg-white">
            <SelectValue />
          </SelectTrigger>
          <SelectContent className="border border-slate-200 bg-white">
            <SelectItem value="INR">INR ₹</SelectItem>
            <SelectItem value="USD">USD $</SelectItem>
            <SelectItem value="ALL">All (converted)</SelectItem>
          </SelectContent>
        </Select>
      </Field>
      {showGranularity && (
        <Field label="Group By">
          <Select value={filters.granularity} onValueChange={set("granularity")}>
            <SelectTrigger data-testid="filter-granularity" className="h-9 rounded-md border-slate-300 bg-white">
              <SelectValue />
            </SelectTrigger>
            <SelectContent className="border border-slate-200 bg-white">
              <SelectItem value="daily">Daily</SelectItem>
              <SelectItem value="weekly">Weekly</SelectItem>
              <SelectItem value="monthly">Monthly</SelectItem>
              <SelectItem value="yearly">Yearly</SelectItem>
            </SelectContent>
          </Select>
        </Field>
      )}
    </div>
  );
};
